import React from 'react';
import BotaoDinamicoListPageContainer from './BotaoDinamicoListPageContainer';

export class BotaoDinamicoListPage extends React.Component{
    
    render(){
      return (
        <BotaoDinamicoListPageContainer {...this.props}/>
      )
    }
}


